import { axios } from "@/plugins/http-request.js";

const state = {};

const getters = {};

const actions = {
  getScreens(context, payload) {
    return axios
      .get("/api/member-admin/screens", {
        params: payload,
      })
      .then((res) => res.data);
  },
  // getScreens() {
  //   return axios
  //     .get(`/api/member-admin/group/name-get`)
  //     .then((res) => res.data);
  // },
  getMemberGroups(context, payload) {
    return axios
      .get("/api/member-admin/group", {
        params: payload,
      })
      .then((res) => res.data);
  },
  getMemberGroupDetails(context, id) {
    return axios.get(`/api/member-admin/group/${id}`).then((res) => res.data);
  },
  createMemberGroup(context, payload) {
    return axios
      .post("/api/member-admin/group", payload)
      .then((res) => res.data);
  },
  updateMemberGroup(context, payload) {
    return axios
      .patch("/api/member-admin/group/" + payload.id, payload.data)
      .then((res) => res.data);
  },
  deleteMemberGroup(context, id) {
    return axios
      .delete("/api/member-admin/group/" + id)
      .then((res) => res.data);
  },
  changeMemberGroupStatus(context, payload) {
    return axios
      .patch(
        "/api/member-admin/group/action/action_mark_" + payload.action,
        payload.data
      )
      .then((res) => res.data);
  },
  getGroups(context, payload) {
    return axios
      .get("/api/member-admin/group/name-get", {
        params: payload,
      })
      .then((res) => res.data);
  },
  getMembers(context, payload) {
    return axios
      .get("/api/member-admin/user", {
        params: payload,
      })
      .then((res) => res.data);
  },
  getMemberDetails(context, id) {
    return axios.get(`/api/member-admin/user/${id}`).then((res) => res.data);
  },
  createMember(context, payload) {
    return axios
      .post("/api/member-admin/user", payload)
      .then((res) => res.data);
  },
  updateMember(context, payload) {
    return axios
      .patch("/api/member-admin/user/" + payload.id, payload.data)
      .then((res) => res.data);
  },
  deleteMember(context, id) {
    return axios.delete("/api/member-admin/user/" + id).then((res) => res.data);
  },
  changeMemberStatus(context, payload) {
    return axios
      .patch(
        "/api/member-admin/user/action/action_mark_" + payload.action,
        payload.data
      )
      .then((res) => res.data);
  },
  getClientAddresses(context, id) {
    return axios.get(`/api/client-address/list/${id}`).then((res) => res.data);
  },

  getClientAddress(context, id) {
    return axios.get("/api/client-address/edit/" + id).then((res) => res.data);
  },
  deleteClientAddress(context, id) {
    return axios.delete("/api/client-address/" + id).then((res) => res.data);
  },
  createClientAddress(context, payload) {
    return axios
      .post(`/api/client-address/create/${payload.id}`, payload.params)
      .then((res) => res.data);
  },
  updateClientAddress(context, payload) {
    return axios
      .patch(
        `/api/client-address/update/${payload.id}/${payload.address_id}`,
        payload.data
      )
      .then((res) => res.data);
  },
  getAlertSettings() {
    return axios.get("/api/carrier-alert-settings").then((res) => res.data);
  },
  updateAlertSettings(context, payload) {
    return axios
      .patch("/api/carrier-alert-settings", payload)
      .then((res) => res.data);
  },
  getClients(context, payload) {
    return axios
      .get("/api/clients/list", {
        params: payload,
      })
      .then((res) => res.data);
  },
  getClient(context, id) {
    return axios.get("/api/clients/edit/" + id).then((res) => res.data);
  },
  fetchClient(context, payload) {
    return axios
      .get("/api/clients/dropdown_list?sortBy[]=name&sortDesc[]", {
        params: payload,
      })
      .then((res) => res.data);
  },
  deleteClient(context, id) {
    return axios.delete("/api/clients/" + id).then((res) => res.data);
  },
  createClient(context, payload) {
    return axios.post("/api/clients/create", payload).then((res) => res.data);
  },
  updateClient(context, payload) {
    return axios
      .patch("/api/clients/update/" + payload.id, payload.data)
      .then((res) => res.data);
  },
  sendClientInvite(context, payload) {
    return axios
      .patch("/api/clients/action/action_send_invite", payload)
      .then((res) => res.data);
  },
  sendUserInvite(context, payload) {
    return axios
      .patch("/api/member-admin/user/action/action_send_invite", payload)
      .then((res) => res.data);
  },
  getUserCategoryScreen(context, id) {
    return axios
      .get(`/api/user-category-screen?user_category=${id}`)
      .then((res) => res.data);
  },
  getScreensList() {
    return axios.get("/api/user-screen-list").then((res) => res.data);
  },
  screenStatusChange(context, payload) {
    return axios
      .post("/api/user-screen/change_status", payload)
      .then((res) => res.data);
  },

  updateScreenApi(context, payload) {
    return axios
      .patch(`/api/user-screen-edit/${payload.id}`, payload)
      .then((res) => res.data);
  },
  saveUserCategoryScreen(_, payload) {
    return axios
      .post(`/api/user-category-screen`, payload)
      .then((res) => res.data);
  },
  addScreen(_, payload) {
    return axios.post(`/api/user-screen/add`, payload).then((res) => res.data);
  },
  // getSellers(_, payload) {
  //   return axios
  //     .get(`/api/seller/seller-active-list/${payload.client_id}`, {
  //       params: payload.params,
  //     })
  //     .then((res) => res.data);
  // },
  warehouseDetail() {
    return axios.get(`/api/pas_users_type`).then((res) => res.data);
  },
  getvendorDropdown() {
    return axios.get(`/api/vendor-dropdown`).then((res) => res.data);
  },
  getSellersActiveList(context, payload) {
    return axios
      .get(`/api/seller/seller-active-list`, {
        params: payload,
      })
      .then((res) => res.data);
  },
  updateClientSetting(context, payload) {
    return axios
      .post(`/api/client/settings/create-or-edit`, payload)
      .then((res) => res.data);
  },
  generateToken(context, id) {
    return axios
      .post(`/api/client/generate-token/create/${id}`)
      .then((res) => res.data);
  },
  getTokenList(context, id) {
    return axios
      .get(`/api/client/generate-token/list/${id}`)
      .then((res) => res.data);
  },
  getSettingList(context, id) {
    return axios.get(`/api/client/settings/list/${id}`).then((res) => res.data);
  },
  updateTokenList(context, payload) {
    return axios
      .patch(
        `/api/client/generate-token/${payload.client_id}/${payload.id}/toggle/${payload.status}`
      )
      .then((res) => res.data);
  },
  getClientAddList() {
    return axios.get(`/api/clients/add`).then((res) => res.data);
  },
  fetchCityList(_, id) {
    return axios
      .get(`/api/${id}/cities?sortBy[]=name&sortDesc[]`)
      .then((res) => res.data);
  },
  unlinkedLogo(context, payload) {
    return axios
      .patch("/api/client/delete-logo/" + payload.id, payload.data)
      .then((res) => res.data);
  },
  getClientApiTracking(_, payload) {
    return axios
      .get(`/api/fulfillmentbb/client_api_pending_summary`, {
        params: payload,
      })
      .then((res) => res.data);
  },
  getClientApiTrackingSummary(_, payload) {
    return axios
      .get(`/api/fulfillmentbb/client_api_failed_transactions`, {
        params: payload,
      })
      .then((res) => res.data);
  },

  clientTrackingRetriger(context, payload) {
    return axios
      .patch(
        "/api/fulfillmentbb/client_api_retrigger_failed_transactions/" +
          payload.id,
        payload
      )
      .then((res) => res.data);
  },
  clientTrackingEdit(context, payload) {
    return axios
      .patch(
        "/api/fulfillmentbb/client_api_retrigger_failed_transactions/" +
          payload.id,
        payload.data
      )
      .then((res) => res.data);
  },
  clientTransactionEdit(context, payload) {
    return axios
      .patch(
        "/api/fulfillmentbb/client_api_closed_transaction/update/" + payload.id,
        payload.data
      )
      .then((res) => res.data);
  },
};

const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations,
};
